<template>
  <section :class="['accordion__item', { 'accordion__item--active': active }]">
    <div class="accordion__item__title" @click="handleAccordionClick">
      <h3 v-html="title"></h3>
    </div>
    <div class="accordion__item__body">
      <p v-html="processedText"></p>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { handleFAQClick } from "@/services/gtm";

export default {
  props: ["title", "text"], // text com placeholders
  data() {
    return {
      active: false,
    };
  },
  methods: {
    handleAccordionClick() {
      handleFAQClick(this.title);
      this.active = !this.active;
    },
    replacePlaceholders(text, values) {
      if (!text || !values) return text;
      return text
        .replaceAll("{{valor_mensalidade}}", `${values.valor}`)
        .replaceAll("{{valor_clinicogeral}}", `${values.clinico_geral}`)
        .replaceAll("{{valor_demaisespecialidades}}", `${values.demais}`)
        .replaceAll("{{valor_anuidadetimes}}", `${values.anuidadeTimes}`)
        .replaceAll(
          "{{valor_anuidadetimes_12X}}",
          `${(Number(values.anuidadeTimes.replace(",", ".")) / 12)
            .toFixed(2)
            .toString()
            .replace(".", ",")}`
        );
    },
  },
  computed: {
    ...mapGetters(["cdtPrices"]), // Obtém os valores da store
    processedText() {
      // Processa o texto com os placeholders substituídos
      return this.replacePlaceholders(this.text, this.cdtPrices);
    },
  },
};
</script>

<style lang="scss">
.accordion {
  &__item {
    background: RGBA(255, 255, 255, 0.7);
    border-radius: 10px;
    padding: 0px 13px;
    margin-bottom: 20px;
    text-align: center;
    @include media(">=tablet") {
      padding: 0px 20px;
      text-align: left;
    }
    &--active {
      .accordion__item__body {
        padding: 20px 0;
        max-height: 1000px;
      }
    }
    &__body {
      max-height: 0px;
      overflow: hidden;
      transition: 0.4s ease-in-out;
    }
    &__title {
      padding: 17px 0 19px;
      cursor: pointer;
      &:hover {
        h3 {
          font-weight: 900;
        }
      }

      h3 {
        border-radius: 10px;
        color: $color-black;
        width: 100%;
        text-decoration: none;
        font-weight: 400;
        font-size: 13px;
        justify-content: center;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        @include media(">=tablet") {
          font-size: 14px;
          display: flex;
        }
        strong {
          font-weight: 900;
          margin: 0 4px;
        }
      }
    }
  }
}
</style>
